<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>签到反馈</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="marketFormRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-form-item label="门店名称"
                      prop="marketname">
          <el-input v-model="form.marketname"
                    placeholder="请输入门店名称" />
        </el-form-item>
        <el-form-item label="地址"
                      prop="address">
          <el-input v-model="form.address"
                    placeholder="请输入地址"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="省份"
                      prop="areaid">
          <cascader-district
            size="small"
            style="width: 200px;"
            v-model="areaid"
            @change="onGetProvinceInfo"
            :changeOnSelect="false" />
        </el-form-item>
        <el-form-item label="坐标类型"
        >
          <el-select class="width-max"
                     v-model="form.map_type"
                     placeholder="请选择坐标类型"
                     clearable>
            <el-option
              v-for="item in options.map_type"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="form.map_type === 0">
          <el-form-item label="百度经度"
                        prop="longitude">
            <el-input v-model="form.longitude"
                      placeholder="请输入百度经度"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="百度纬度"
                        prop="latitude">
            <el-input v-model="form.latitude"
                      placeholder="请输入百度纬度">
            </el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="form.map_type === 1"
                      label="高德经度"
                      prop="lon_gd" >
          <el-input v-model="form.lon_gd"
                    placeholder="请输入高德经度"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item v-if="form.map_type === 1"
                      label="高德纬度"
                      prop="lat_gd">
          <el-input v-model="form.lat_gd"
                    placeholder="请输入高德纬度">
          </el-input>
        </el-form-item>

        <el-form-item label="零工签到经度">
          <span>{{feedback.longitude}}</span>
        </el-form-item>
        <el-form-item label="零工签到纬度">
          <span>{{feedback.latitude}}</span>
        </el-form-item>
        <el-form-item label="图片证据">
          <el-image
            v-for="(image, index) in feedback.photos"
            :key="index"
            style="margin-right: 10px;width: 120px; height: 120px"
            :src="image"
            :preview-src-list="feedback.photos">
          </el-image>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">保存
          </el-button>
          <router-link :to="{ path: '/platform/sign-feedback-table'}">
            <el-button>取消</el-button>
          </router-link>
        </el-form-item>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { marketFormRules } from '../platform.rules.js'
import WangEditor from '@components/WangEditorV3Deprecated'
import CascaderDistrict from '@/views/area/components/CascaderDistrict'

export default {
  components: {WangEditor, CascaderDistrict},
  data () {
    return {
      marketFormRules,
      selectLoading: false,
      areaid: [],
      form: {
        id: null,
        marketname: null,
        address: null,
        provinceid: null,
        cityid: null,
        areaid: null,
        map_type: 1,
        longitude: null,
        latitude: null,
        lat_gd: null,
        lon_gd: null,
      },
      feedback: {
        longitude: null,
        latitude: null,
        photos: []
      }
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.market.options,
    }),
  },
  created () {
    this.onGetSignFeedBack()
  },
  methods: {
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          request.common('updateMarketData', this.form).then((res) => {
            this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/platform/sign-feedback-table'})
            })
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    onGetSignFeedBack () {
      return request.page('getMarketInvalidFeedbackDetail', this.$route.query.id).then((data) => {
        filter.setLoop(this.form, data.data.market)
        this.areaid = [
          String(data.data.market.provinceid),
          String(data.data.market.cityid),
          String(data.data.market.areaid)
        ]
        this.feedback.longitude = data.data.longitude
        this.feedback.latitude = data.data.latitude
        this.feedback.photos = data.data.photos

        // 1-9 百度 >10 高德
        if (data.data.market.gpsinfo_status > 9) {
          this.form.map_type = 1
        }
      })
    },
    onGetProvinceInfo (value) {
      if (value.length === 3) {
        this.form.provinceid = value[0]
        this.form.cityid = value[1]
        this.form.areaid = value[2]
      }
    },
  },

}
</script>
<style lang="scss"
       scoped>
.avatar-uploader {
  width: 148px;
  height: 148px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/platform/pages/SignFeedBackForm.vue